import { InjectionToken } from '@angular/core';
import type { PublicAppConfig } from '#models';

/**
 * Angular DI token that holds the MSAL public configuration fetched from
 * the ARES API at startup (sourced from Azure Key Vault).
 * Provided in main.ts before bootstrapApplication() is called.
 */
export const APP_PUBLIC_CONFIG = new InjectionToken<PublicAppConfig>('APP_PUBLIC_CONFIG');
